import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  select: {
    "& .MuiSelect-select": {
      height: "24px",
      padding: "0",
      minHeight: "auto",
      width: "32px"
    },
    "& fieldset": {
      border: "none"
    },
    "& .yellow": { background: "#ffd200" },
    "& .darkblue": {
      background: "#440073"
    },
    "& .red": {
      background: "#FF014D"
    },
    "& .green": {
      background: "#12494E"
    }
  },
  menuItem: {
    height: "24px",
    width: "100%",
    padding: "0",
    "& .yellow": { background: "#ffd200" },
    "& .darkblue": {
      background: "#440073"
    },
    "& .red": {
      background: "#FF014D"
    },
    "& .green": {
      background: "#12494E"
    }
  },
  themeCircle: {
    margin: "0",
    display: "flex",
    padding: "0",
    borderRadius: "8px",
    overflow: "hidden",
    width: "100%",
    height: "100%",
    "& div": {
      width: "50%"
    }
  },
  popper: {
    minWidth: "32px !important",
    transform: "translateX(-18px) !important",
    marginTop: "4px",
    background: "transparent",
    "& ul": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: "0",
      margin: "0",
      rowGap: "1px"
    },
    "& hr": {
      border: `1px solid ${theme?.palette?.primaryText?.[200]}`,
      margin: "0"
    }
  }
}));
